import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PaperIconComponent } from '@ricoh-paper/angular';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'dp-action-shelf',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaperIconComponent,
    TranslocoPipe,
  ],
  templateUrl: './action-shelf.html',
  styleUrl: './action-shelf.scss',
})
export class ActionShelfComponent {
  readonly visible = input(false);
  readonly isFavourite = input(false);
  /** When true, renders a third destructive-tinted button beneath share that
   *  emits `cancel`. Used by `book-meeting-panel` view-mode footer to surface
   *  Cancel Meeting alongside share without bolting on a separate floating
   *  bar. Defaults to false so the space-detail-panel callsite is unchanged. */
  readonly showCancel = input(false);
  /** Hides the favourite button when false. Meeting panel doesn't have a
   *  favourite concept; this lets it reuse the shelf without an empty slot. */
  readonly showFavourite = input(true);

  favourite = output<void>();
  share = output<void>();
  cancel = output<void>();
}
